import axios from 'axios';
import { getCookie, clearCookie } from './cookies';
import { env } from './function';

axios.defaults.baseURL = env('SERVER');
// axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
    const accessToken = getCookie('accessToken');
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
});

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const status = error?.response?.status;
        if (status === 401) {
            clearCookie('accessToken');
            clearCookie('role');
            localStorage.clear();
            if (typeof window !== 'undefined') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
